import { ROUTE_PATH } from 'common/constants/sm-constants';
import { GridMetaModel, Headers } from 'common/models/utility-models/meta-model';
import { UsersModel } from './user-data-model';



export class UsersGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Users',
            ROUTE_PATH.userGrid,
            ROUTE_PATH.addUser,
            true,
            true,
            8,
            false,
            true,
            ['name', 'email'],
            false,
            [],
            {
                isDownloadExcel: false, excelFileName: '',
                btnLabel: '', headers: []
            },
            false,
            {},
            false,
            false,
            true,
            null,
            { evalKey: 'wantToDelete', evalParam: [1], decisiveParam: false }
           
            
        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const name = new Headers('Name', 'name', false, true, 'text');
        const email = new Headers('Email', 'email', false, true, 'text');

        headers.push(name);
        headers.push(email);
        return headers;
    }
}   

export { UsersModel };